import { Link, useLoaderData } from "react-router-dom";
import * as API from "../services/who5";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getWho5ByID(params.who5Id);
}

export function Who5PacienteItem(props) {
  const who5 = useLoaderData();
  const errorMessage = who5.message;

  const who5Resp = who5.meta?.who5Resp;
  const metaFecha = who5.meta?.metaFecha;
  const who5Alegre = who5.meta?.who5Alegre;
  const who5Tranquilo = who5.meta?.who5Tranquilo;
  const who5Activo = who5.meta?.who5Activo;
  const who5Despejado = who5.meta?.who5Despejado;
  const who5Interesan = who5.meta?.who5Interesan;

  const who5Date = new Date(who5.date);
  const diffDate = Math.abs(new Date() - who5Date) / 36e5;

  // Sum of all WHO-5 test responses
  const totalSumWho5 =
    4 *
    ((parseInt(who5Alegre) || 0) +
      (parseInt(who5Tranquilo) || 0) +
      (parseInt(who5Activo) || 0) +
      (parseInt(who5Despejado) || 0) +
      (parseInt(who5Interesan) || 0));

  const createResultProperties = (result, low, high) => {
    // Convertir los strings que vienen del meta a numbers
    result = parseFloat(result);
    low = parseFloat(low);
    high = parseFloat(high);
    const color =
      result >= low && result <= high
        ? "anali-result-good"
        : "anali-result-bad";
    const markIn = Math.min(
      Math.max(((result - low) / (high - low)) * 100, 0),
      100
    ).toFixed(0);
    const markOut =
      result < low
        ? "anali-result-low"
        : result > high
        ? "anali-result-high"
        : "";
    return { color, markIn, markOut };
  };

  // Graphics
  const limits = {
    compT: { low: 0, high: 100 },
  };

  const {
    color: sumCompTColor,
    markIn: sumCompTMarkIn,
    markOut: sumCompTMarkOut,
  } = createResultProperties(totalSumWho5, limits.compT.low, limits.compT.high);


  return (
    <>
      <div id='content'>
        {who5.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : (
          <>
          <form id='formUpdatelement' className='newRadioButtons'>
            <fieldset id='disabledContainer' disabled='disabled'>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='metaFecha'>Fecha de Respuesta al Cuestionario</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='metaFecha'
                      required
                      type='date'
                      value={metaFecha}
                      readOnly
                    />
                  </div>
                </div>
              </div>

            </fieldset>
          </form>
          <form className="analitic-form">
              <h3>Cuestionario WHO-5</h3>
              <div className="three-col-analitic">

                {/* Componente 0: Puntuación Global */}
                <div className="anali-el">
                  <p className="anali-title">Puntuación Global</p>
                  <div className="anali-result-container">
                    <p className={`anali-result ${sumCompTColor}`}>
                      {totalSumWho5}
                    </p>
                    <div className={`anali-bar-full ${sumCompTMarkOut}`}>
                      <div className="anali-bar anali-bar-low"></div>
                      <div className="anali-bar anali-bar-main">
                        <div
                          className="anali-bar-mark"
                          style={{
                            left: `${sumCompTMarkIn}%`,
                          }}
                        ></div>
                      </div>
                      <div className="anali-bar anali-bar-high"></div>
                    </div>
                    <div className="anali-limit-container">
                      <p className="anali-limit anali-limit-low">
                        {limits.compT.low}
                      </p>
                      <p className="anali-limit anali-limit-high">
                        {limits.compT.high}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
          </form>
        </>
        )}
      </div>


      {!errorMessage && (
        <div id='actions'>
        </div>
      )}
    </>
  );
}
